import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import {Card, Button, Icon} from 'semantic-ui-react';
import {getElapsedTime, getElapsedTimeLikeString} from '../../../common/util/time';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {Actions} from '../../../common/actions';
import {paths} from '../../../common/dictionaries/urls';
import StoragePageTable from './table';
import './storage.scss';

let timer = null;
let startTime = null;

const formatElapsedTime = (elapsedTime) => {
  const timeComplete = elapsedTime.split(' ');
  const days = timeComplete[0] ? timeComplete[0].replace('d', '') : '';
  const time = timeComplete[1].split(':');

  return (
    <div className='elapsed-time'>
      <span className='label'><strong>Tiempo Recorrido</strong></span>
      <span className='number'>{days}</span><span>{days ? 'd ' : ''}</span>
      <span className='number'>{time[0]}</span><span>H </span>
      <span className='number'>{time[1]}</span><span>M </span>
      <span className='number'>{time[2]}</span><span>S</span>
    </div>
  );
};

class StoragePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'elapsedTime': '',
      'storageSessionWasChecked': false,
      'storageCarWasStopped': false,
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.BinningStorage, scopes.See)) {
      this.props.push(paths.AccessDenied);
      return;
    }
    this.loadInitalData();
  }

  loadInitalData() {
    this.props.emptyInfo();
    this.props.fetchStorageCars('filled');
    this.props.checkUserStorageSession();
  }

  componentDidUpdate() {
    const {storageSessionWasChecked, storageCarWasStopped} = this.state;
    const {storageSession} = this.props;

    if (storageSession.hasOpenSession && !storageSessionWasChecked) {
      this.setState({
        'storageSessionWasChecked': true,
        'storageCarWasStopped': false,
      });
      this.props.fetchPendingLinesToStorageByCar(storageSession.storageCar, 'inStorage');
      const elapsedTime = parseInt(storageSession.elapsedTime, 10);
      this.initTimer(elapsedTime);
    }

    if (!storageSession.hasOpenSession && !storageCarWasStopped) {
      this.setState({'storageCarWasStopped': true});
      this.stopTimer();
    }
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  stopTimer() {
    if (timer) {
      this.setState({'elapsedTime': ''});
      clearInterval(timer);
    }
  }

  renderStorageCarsFilledSection() {
    const {listStorageCarsFilled, storageCarSelected} = this.props;
    if (!listStorageCarsFilled.length) {
      return (
        <span className='storage-cars-empty'>
          Por el momento no hay coches disponibles para el proceso de guardado
        </span>
      );
    }

    return listStorageCarsFilled.map((storageCar, index) => {
      const color = storageCar === storageCarSelected ? 'red' : 'grey';
      return (
        <span key={index} className='storage-car' onClick={this.changeStorageCar.bind(this, storageCar)}>
          <span className='storage-car-number'>{storageCar}</span>
          <Icon name='shopping cart' size='huge' color={color} />
        </span>
      );
    });
  }

  changeStorageCar(value) {
    const {savingLines, storageCarSelected} = this.props;

    if (savingLines || value === storageCarSelected) {
      return;
    }
    this.setState({
      'storageSessionWasChecked': false,
      'storageCarWasStopped': false,
    });
    this.props.fetchPendingLinesToStorageByCar(value);
  }

  onRefreshClick() {
    this.loadInitalData();
  }

  renderTimerSection() {
    const {savingLines, timerStarted, storageCarSelected, stoppingTimer} = this.props;
    const {elapsedTime} = this.state;
    if (!storageCarSelected) {
      return null;
    }
    if (savingLines && timerStarted) {
      return (
        <div className='stop-timer'>
          {elapsedTime}
          <Button
            primary
            type='submit'
            className='toyota-primary'
            disabled={savingLines && stoppingTimer}
            loading={savingLines && stoppingTimer}
            onClick={this.onStopTimer.bind(this)}
          >
            Detener
          </Button>
        </div>
      );
    }

    return (
      <div className='start-timer'>
        <Button
          primary
          type='submit'
          className='toyota-primary'
          disabled={savingLines}
          loading={savingLines}
          onClick={this.onInitTimer.bind(this)}
        >
          Iniciar
        </Button>
      </div>
    );
  }

  onInitTimer() {
    const {storageCarSelected} = this.props;
    const data = storageCarSelected === 'G' ? {'lineCodes': this.getLinesCodes()} : {};
    
    this.props.changeStorageCarStatus(storageCarSelected, 'startStorage', data);
  }

  initTimer(elapsedTime) {
    startTime = moment();
    const self = this;
    timer = setInterval(function() {
      const newElapsedTime = getElapsedTimeLikeString(startTime, elapsedTime);
      self.setState({'elapsedTime': formatElapsedTime(newElapsedTime)});
    }, 1000);
  }

  onStopTimer() {
    const {storageCarSelected, storageSession} = this.props;
    const currentTime = moment();
    const elapsedTime = getElapsedTime(currentTime, startTime, storageSession.elapsedTime).asSeconds();
    const data = storageCarSelected === 'G' ? {'lineCodes': this.getLinesCodes(), elapsedTime} : {elapsedTime};
    this.props.changeStorageCarStatus(storageCarSelected, 'endStorage', data);
  }

  getLinesCodes() {
    const {pendingLinesList} = this.props;
    return pendingLinesList.map((line) => line.code);
  }


  renderLines() {
    const {storageCarSelected, loading, pendingLinesList} = this.props;
    if (!storageCarSelected) {
      return null;
    }
    
    return (
      <Card fluid raised className='primary-content'>
        <div className='title-bar'>
          <div className='title'>
            <h3>Cantidad de Items</h3>
            <span className='quantity-container'>
              {_.sumBy(pendingLinesList, 'quantity')}
            </span>
          </div>
        </div>

        <StoragePageTable loading={loading} pendingLinesList={pendingLinesList} />
      </Card>
    );
  }

  render() {
    const {loadingStorageCarsFilled, savingLines} = this.props;

    return (
      <div className='storage-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Binning - Guardado</h2>
              <div className='title-bar-actions'>
                {this.renderTimerSection()}
              </div>
            </div>
            <div className='subtitle'>
              Seleccione un coche para iniciar el proceso de guardado
            </div>
            <div className='storage-cars-container'>
              {this.renderStorageCarsFilledSection()}
              <Button
                type='button'
                primary
                className='toyota-primary refresh'
                disabled={loadingStorageCarsFilled || savingLines}
                loading={loadingStorageCarsFilled}
                onClick={this.onRefreshClick.bind(this)}
              >
                <Icon name='refresh' size='large' />
              </Button>
            </div>
          </div>
        </Card>
        {this.renderLines()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingStorageCarsFilled': state.storage.loadingStorageCarsFilled,
    'listStorageCarsFilled': state.storage.listStorageCarsFilled,
    'storageSession': state.storage.storageSession,
    'storageCarSelected': state.storage.storageCarSelected,
    'loading': state.storage.loadingLines,
    'pendingLinesList': state.storage.pendingLinesList,
    'savingLines': state.storage.savingLines,
    'timerStarted': state.storage.timerStarted,
    'stoppingTimer': state.storage.stoppingTimer,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  emptyInfo,
  fetchStorageCars,
  checkUserStorageSession,
  fetchPendingLinesToStorageByCar,
  addMessageBoxError,
  changeStorageCarStatus,
} = Actions;

export default connect(mapStateToProps, {
  emptyInfo,
  fetchStorageCars,
  checkUserStorageSession,
  fetchPendingLinesToStorageByCar,
  addMessageBoxError,
  changeStorageCarStatus,
})(StoragePage);
